<template>
  <component :is="tag" :data-i18n="code" :class="className">{{ translatedText }}</component>
</template>

<script>
/**
 * Composant Ti18n (Translation)
 *
 * Affiche une traduction avec l'attribut data-i18n pour permettre
 * l'identification du code de traduction dans le DOM.
 *
 * Usage:
 *   <T code="appTranslation.quickEdit.title" />
 *   <T code="common.save" tag="span" />
 *   <T code="app.title" tag="h1" class="text-h4" />
 *
 * Rendu:
 *   <span data-i18n="appTranslation.quickEdit.title">Édition rapide de traduction</span>
 */
export default {
  name: 'Ti18n',

  props: {
    // Code de traduction i18n
    code: {
      type: String,
      required: true
    },
    // Balise HTML à utiliser (par défaut: span)
    tag: {
      type: String,
      default: 'span'
    },
    // Classes CSS additionnelles
    className: {
      type: String,
      default: ''
    },
    // Paramètres de substitution pour les traductions avec placeholders
    params: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    translatedText() {
      if (Object.keys(this.params).length > 0) {
        return this.$t(this.code, this.params);
      }
      return this.$t(this.code);
    }
  }
};
</script>
